import { Component, NgZone, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AvailableConfigurations } from '../../services/Ebootis.Queries/AvailableConfigurations';
import { ServiceWorkerService } from '../../services/service-worker.service';
import { ConfigurationService } from '../configuration-select/configuration.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnDestroy {

	private m_subscriptionsSubject = new Subject();

	public m_configurations$: Observable<AvailableConfigurations.Result[]> = this.m_configurationService.getConfigurations();

	constructor(
		private m_configurationService: ConfigurationService,
		private m_router: Router,
		private ngZone: NgZone,
		private serviceWorkerService: ServiceWorkerService
	) { }

	/**
	 * Die Subscriptions werden geschlossen.
	 */
	public ngOnDestroy(): void {
		this.m_subscriptionsSubject.next(null);
		this.m_subscriptionsSubject.complete();
	}

	/**
	 * Die verfügbaren Konfigurationen werden geladen. Falls es nur eine Konfiguration gibt wird sofort auf die Übersicht gewechselt.
	 */
	public loggedIn(p_loggedIn: boolean) {
		if (p_loggedIn) {
			if (this.serviceWorkerService.isEnabled())
				this.serviceWorkerService.checkForUpdates()
			this.redirect();
		}

	}

	private redirect() {
		this.m_configurations$
			.pipe(takeUntil(this.m_subscriptionsSubject))
			.subscribe({
				next: (res) => {
					if (res != null && res.length == 1) {
						this.m_configurationService.setConfiguration(res[0].oid);
						/**
						 * https://stackoverflow.com/questions/53133544/angular-7-routerlink-directive-warning-navigation-triggered-outside-angular-zon/53213909
						 * 
						 */
						this.ngZone.run(() => this.m_router.navigate(['./uebersicht'])).then();
					} else {
						this.ngZone.run(() => this.m_router.navigate(['./systemauswahl'])).then();
					}
				},
			});
	}


}
